export const warning_ValidEmailText = "Please enter a valid email address"
export const warning_MandatoryText = "Please complete the below mandatory fields before continuing"
export const warning_NHSNumberText = "Please enter the NHS number"
export const warning_SelectStageText = "Please select a cancer stage"